module.exports = __webpack_public_path__ + "media/shape/border-7b54f598.png";